import { IAnimationControllerConfiguration, Inject, SimpleBaseController } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';

import { AnimationContents } from '../../../AnimationContents';

import { Graphics } from 'pixi.js';

export interface ISliderControllerOptions {
    trackLength: number;
    onScroll(value: number):number;
}

export class SliderController extends SimpleBaseController {
    $model: GameModel;

    public button: PIXI.Graphics;

    private _button: PIXI.Graphics;
    private _track: PIXI.Graphics;
    private _data: any; // mouse _data;
    private _dragging: boolean;
    private _trackLength: number;

    public constructor(
        @Inject private _options: ISliderControllerOptions,
        // @Inject private _gameLogic: GameLogic,
    ) {
        super('SliderController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.FRIENDS_LIST_MODAL_JSON,
            libraryName: 'friend_row',
            childControllers: {

            },
        };
    }

    protected onInitialize() {
        this._trackLength = this._options.trackLength ? this._options.trackLength : 300

        this._button = new Graphics;
        this.button = this._button;
        this._track = new Graphics;

        this._track.lineStyle(2, 0xff0000);
        this._track.beginFill(0x000000, 1);
        this._track.drawRect(0, -5, this._trackLength, 10)

        this._button.lineStyle(2, 0xff0000);
        this._button.beginFill(0x0000ff, 0.3);
        this._button.drawRect(-40, -20, 80, 40);
        this._button.lineStyle(0, 0xff0000);
        this._button.beginFill(0xff0000, 0.3);
        this._button.drawCircle(0, 0, 2)

        this.display.addChild(this._track, this._button);


        this._button.interactive = true
        this._button
            .on('pointerover', () => {
                this._button.tint = 0xff00ff
                // this.emit('pointerover', this)
            })
            .on('mouseupoutside', () => {
                this._data = null
                console.log('mouseupoutside')
                this._dragging = false
                this._button.tint = 0xffffff
                // this.emit('pointerout', this)
            })
            .on('touchmove', (e) => {
                console.log('touchmove', e)
                if (e.target) return
                this._data = null

                this._dragging = false
                this._button.tint = 0xffffff
                // this.emit('pointerout', this)
            })
            .on('touchendoutside', () => {
                this._data = null
                console.log('touchendoutside')
                this._dragging = false
                this._button.tint = 0xffffff
                // this.emit('pointerout', this)
            })
            .on('pointerdown', (event) => {
                this._data = event.data
                // console.log('set _data')
                this._dragging = true
                this._button.tint = 0x00452f
                // this.emit('pointerdown', this)
            })
            .on('pointerup', () => {
                this._data = null
                // console.log('clear _data')
                this._dragging = false
                this._button.tint = 0xffffff
                // this.emit('pointerup', this)
            })
            .on('pointermove', () => {
                if (this._dragging) {
                    const newPosition = this._data.getLocalPosition(this._button.parent);
                    if (newPosition.x <= 0) {
                        this._button.x = 0;
                    } else if (newPosition.x >= this._trackLength) {
                        this._button.x = this._trackLength
                    } else {
                        this._button.x = newPosition.x;
                    }
                    if (typeof this._options.onScroll === 'function')
                        this._options.onScroll(this._button.x / this._trackLength);
                }
            })


    }

    protected onUpdate(frameRate: number) {

    }

    public scroll(delta:number) {
        const x = this.button.x + delta
        if (x <= 0) {
            this._button.x = 0;
        } else if (x >= this._trackLength) {
            this._button.x = this._trackLength
        } else {
            this._button.x = x;
        }
        if (typeof this._options.onScroll === 'function')
            this._options.onScroll(this._button.x / this._trackLength);
    }
}
